import React, { useContext } from 'react';
import TabPanel from '../TabPanel';
import { SettingsModalTabProps } from '../types';
import ProjectTemplatesSection from './ProjectTemplateSection';
import GlobalSettingsSection from './GlobalSettingsSection';
import CompanyContractTypesSection from './CompanyContractTypesSection';
import KickOffTemplatesSection from './KickOffTemplateSection';
import CurrentUserContext from '@/Contexts/CurrentUser';
import OverwatchAccordion from '@/components/OverwatchAccordion';
import EditCompanyDetails from './EditCompanyDetails';
import SubscriptionSection from './SubscriptionSection';
import PermissionContext from '@/Contexts/Permissions';
import { PermissionActionEnum, PermissionEntityEnum } from '@/graphql/generated/graphql';
import WorkShiftsSection from './WorkShiftsSection';

const CompanySettingsTab: React.FC<SettingsModalTabProps> = ({ parentTab, index, showHeading }) => {
  const { currentUser } = useContext(CurrentUserContext);
  const { canPerformAction } = useContext(PermissionContext);
  const { View } = PermissionActionEnum;
  const { Projects, ProjectKickOff } = PermissionEntityEnum;

  if (!currentUser) return <></>;

  return (
    <TabPanel value={parentTab} index={index} heading="Company Settings" showHeading={showHeading}>
      <EditCompanyDetails />
      { currentUser.isOwner &&
        <OverwatchAccordion title="Subscription">
          <SubscriptionSection />
        </OverwatchAccordion>
      }
      <OverwatchAccordion title="Global Settings">
        <GlobalSettingsSection />
      </OverwatchAccordion>
      {currentUser.isOwner &&
        <OverwatchAccordion title="Work Shifts" height="300px">
          <WorkShiftsSection />
        </OverwatchAccordion>
      }
      {canPerformAction(View, Projects) &&
        <OverwatchAccordion title="Project Templates Management">
          <ProjectTemplatesSection />
        </OverwatchAccordion>
      }
      <OverwatchAccordion title="Company Supported Contracts" height="300px">
        <CompanyContractTypesSection />
      </OverwatchAccordion>
      {canPerformAction(View, ProjectKickOff) &&
        <OverwatchAccordion title="Kick-Off Template Management" height="300px">
          <KickOffTemplatesSection />
        </OverwatchAccordion>
      }
    </TabPanel>
  );
};

export default CompanySettingsTab;
